export default __webpack_public_path__ + "static/media/UKCB-Logo-PassengerApp.5f868503.png";